








































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {EssenceAchat} from '@/models';

import CrudEssenceAchatEdit from '@/components/Crud/EssenceAchat/Edit.vue';
import storeAchat from "@/stores/modules/achat";

@Component({
	components: {
		CrudEssenceAchatEdit,
	}
})
export default class CrudEssenceAchatEditDialog extends Vue {
	@InOut({ type: EssenceAchat  , isVModel: true }) private value!: EssenceAchat;

	@Emit()
	private onSubmit(essenceAchat: EssenceAchat) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}

	private async onAnnuler() {
		this.value = null;
		await storeAchat.dispatch('get', this.value.id);
	}
}
